import { DATE_PLACEHOLDER_TOKENS, DEFAULT_DATE_PLACEHOLDER_TOKENS } from 'Constants';
export const getDifferenceInMinutesFromNow = endDate => {
  const now = new Date().getTime();
  endDate = new Date(endDate * 1000).getTime();
  const difference = endDate - now;
  const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(difference % (1000 * 60) / 1000);
  const time = `${minutes}:${('0' + seconds).slice(-2)}`;
  return {
    time,
    difference
  };
};
export const formatLocalDate = (date, locale) => new Intl.DateTimeFormat(locale, {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
}).format(new Date(date.year(), date.monthValue() - 1, date.dayOfMonth()));
export const formatDatePlaceholder = locale => {
  const tokens = DATE_PLACEHOLDER_TOKENS[locale] ?? DEFAULT_DATE_PLACEHOLDER_TOKENS;
  const parts = new Intl.DateTimeFormat(locale, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  }).formatToParts(new Date(Date.UTC(2024, 0, 9)));
  return parts.map(part => {
    switch (part.type) {
      case 'day':
        return tokens.day;
      case 'month':
        return tokens.month;
      case 'year':
        return tokens.year;
      default:
        return part.value;
    }
  }).join('');
};